import Vue from 'vue';
import Vuex from 'vuex';
import searchHistory from './modules/searchHistory';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        searchHistory
    },
    strict: false
});
